import { CommonHttpOption } from "./../../base/common-http-option";
import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { Observable } from "rxjs";
import { IDiscountGroupByTermInfo } from "src/app/interfaces/discountGroup-byTermInfo";
//import { IDiscountgGroup } from "src/app/interfaces/discount-group";

@Injectable({
  providedIn: "root"
})
export class DiscountGroupService {
  constructor(private core: CoreService) { }

  list(filter: any, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.discountGroup.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
        .append('ContainDetailes', filter && filter.ContainDetailes ? filter.ContainDetailes : false)
    );
  }


  discountByTypeList(isClass: any): Observable<any> {
    return this.core.get(
      ServiceRoute.discountGroup.discountByTypeList + isClass,
      new CommonHttpOption().headers,
    );
  }
  getByID(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.discountGroup.getById + id,
      new CommonHttpOption().headers
    );
  }

  discountPersonByNationalCode(courseId: number, nationalCode: string): Observable<any> {
    return this.core.get(
      ServiceRoute.discountGroup.discountPersonByNationalCode + '?CourseId=' + courseId + '&NationalCode=' + nationalCode,
      new CommonHttpOption().headers
    );
  }
  discountPersonByNationalCodeDirect(courseId: number, nationalCode: string): Observable<any> {
    return this.core.get(
      ServiceRoute.discountGroup.discountPersonByNationalCode + '?CourseId=' + courseId + '&NationalCode=' + nationalCode + '&Direct=true',
      new CommonHttpOption().headers
    );
  }
  getUnderstandingDiscountCombo(courseId: number, nationalCode: string): Observable<any> {
    return this.core.get(
      ServiceRoute.discountGroup.getUnderstandingDiscountCombo + '?CourseId=' + courseId + '&NationalCode=' + nationalCode,
      new CommonHttpOption().headers
    );
  }

  listByLevelInfoAndCoursePattern(
    data: IDiscountGroupByTermInfo
  ): Observable<any> {
    return this.core.post(
      ServiceRoute.discountGroup.ListByLevelInfoAndCoursePattern,
      data,
      new CommonHttpOption().headers
    );
  }

  // discountPersonList(): Observable<any> {
  //   return this.core.get(
  //     ServiceRoute.discountGroup.discountPersonList,
  //     new CommonHttpOption().headers
  //   );
  // }
  discountPersonList(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.student.course.discountPersonListSTU + params.courseId,
      new CommonHttpOption().headers
    );
  }

  addNonClass(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.discountGroup.addOther,
      data,
      new CommonHttpOption().headers
    );
  }

  editNonClass(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.discountGroup.editOther,
      data,
      new CommonHttpOption().headers
    );
  }

  addClassPersonDiscount(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.discountGroup.addClassPersonDiscount,
      data,
      new CommonHttpOption().headers
    );
  }

  editClassPersonDiscount(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.discountGroup.editClassPersonDiscount,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.discountGroup.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  activeDeactive(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.discountGroup.activeDeactive,
      data,
      new CommonHttpOption().headers
    );
  }

  //discount Group Person

  listPersonDocument(filter: any, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.discountGroup.listPersonDocument,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize, "Id", true)
        .append('StudentFullName', filter && filter.StudentFullName ? filter.StudentFullName : '')
        .append('DiscountGroupId', filter && filter.DiscountGroupId ? filter.DiscountGroupId : '')
        .append('NationalCode', filter && filter.NationalCode ? filter.NationalCode : '')
        .append('ActionPersonFullName', filter && filter.ActionPersonFullName ? filter.ActionPersonFullName : '')
        .append('DocumentStatusId', filter && filter.DocumentStatusId ? filter.DocumentStatusId : '')
        .append('Id', filter && filter.Id ? filter.Id : '')
        .append('DiscountPercentStart', filter && filter.DiscountPercentStart ? filter.DiscountPercentStart : '')
        .append('DiscountPercentEnd', filter && filter.DiscountPercentEnd ? filter.DiscountPercentEnd : '')
        .append('ValidityStartDate', filter && filter.ValidityStartDate ? filter.ValidityStartDate : '')
        .append('ValidityEndDate', filter && filter.ValidityEndDate ? filter.ValidityEndDate : '')
    );
  }

  documentAdd(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.discountGroup.documentAdd,
      data,
      new CommonHttpOption().headers
    );
  }
  //edit
  documentChangeDiscountGroup(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.discountGroup.documentChangeDiscountGroup,
      data,
      new CommonHttpOption().headers
    );
  }

  documentConfirmedReject(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.discountGroup.documentConfirmedReject,
      data,
      new CommonHttpOption().headers
    );
  }

  documentDelete(data: any): Observable<any> {

    return this.core.delete(
      ServiceRoute.discountGroup.documentDelete,
      new CommonHttpOption().headers,
      data
    );
  }


}
